import {AnyRouteResult} from '@/app/interfaces/routing';
import {RouteName} from '@/app/constants/routing';
import {ForecastDaysMode} from '@/app/constants/forecast';

export const getPlausiblePageUrl = (route: AnyRouteResult) => {
	if (route.name === RouteName.weather) {
		if (route.data.daysMode === ForecastDaysMode.Days7 && route.data.selectedWeekday !== undefined) {
			return `${location.origin}/weather/location/day`;
		} else if (route.data.daysMode === ForecastDaysMode.Days10 && route.data.selectedDate) {
			return `${location.origin}/weather/location/date`;
		} else if (route.data.daysMode === ForecastDaysMode.Days7) {
			return `${location.origin}/weather/location`;
		} else if (route.data.daysMode === ForecastDaysMode.Days10) {
			return `${location.origin}/weather/location/days10`;
		}
		return `${location.origin}/${route.data.daysMode}`;
	} else if (route.name === RouteName.map) {
		return `${location.origin}/map`;
	}
	return location.origin;
};
